import {
  GET_GENERAL_SUCCESS,
  GET_GENERAL_FAIL,
  GET_COUNTRY_SUCCESS,
  GET_COUNTRY_FAIL,
  GET_STATE_SUCCESS,
  GET_STATE_FAIL,
  GET_CITY_SUCCESS,
  GET_CITY_FAIL,
  RESET_GENERAL_STATE,
  RESET_ATTACHMENT_STATE,
  GET_ATTACHMENT_SUCCESS,
  GET_ATTACHMENT_FAIL,
  RESET_PROFILE_ATTACHMENT_STATE,
  GET_PROFILE_ATTACHMENT_SUCCESS,
  GET_PROFILE_ATTACHMENT_FAIL,
  RESET_THUMBNAIL_ATTACHMENT_STATE,
  GET_THUMBNAIL_ATTACHMENT_SUCCESS,
  GET_THUMBNAIL_ATTACHMENT_FAIL,
  GET_VOUCHER_LIST_SUCCESS,
  GET_VOUCHER_LIST_FAIL,
  SEND_EMAIL_SUCCESS,
  SEND_EMAIL_FAIL,
  RESET_EMAIL_STATE,
  SET_CURRENT_USER,
  GET_REGION_SUCCESS,
  GET_REGION_FAIL,
  GET_ADVERT_INTEREST_RATE_SUCCESS,
  GET_ADVERT_INTEREST_RATE_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  cities: [],
  countries: [],
  roles: [],
  specialty: [],
  customers: [],
  doctors: [],
  payment_methods: [],
  courier_services: [],
  sub_category: [],
  states: [],
  country: [],
  city: [],
  region: [],
  send_email_response: [],
  current_user: [],
  advertInterestRate: [],
}

const General = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_GENERAL_SUCCESS:
      return {
        ...state,
        cities: action.payload.cities,
        countries: action.payload.countries,
        roles: action.payload.roles,
        specialty: action.payload.specialty,
        customers: action.payload.customers,
        doctors: action.payload.doctors,
        payment_methods: action.payload.payment_methods,
        courier_services: action.payload.courier_services,
      }

    case GET_GENERAL_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case SET_CURRENT_USER:
      return {
        ...state,
        current_user: action.payload,
      }

    case GET_COUNTRY_SUCCESS:
      return {
        ...state,
        country: action.payload,
      }

    case GET_COUNTRY_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_STATE_SUCCESS:
      return {
        ...state,
        states: action.payload,
      }

    case GET_STATE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_CITY_SUCCESS:
      return {
        ...state,
        city: action.payload,
      }

    case GET_CITY_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_REGION_SUCCESS:
      return {
        ...state,
        region: action.payload,
      }

    case GET_REGION_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ATTACHMENT_SUCCESS:
      return {
        ...state,
        attachment: action.payload,
      }
    case GET_ATTACHMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_PROFILE_ATTACHMENT_SUCCESS:
      return {
        ...state,
        profileAttachment: action.payload,
      }
    case GET_PROFILE_ATTACHMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_THUMBNAIL_ATTACHMENT_SUCCESS:
      return {
        ...state,
        thumbnailAttachment: action.payload,
      }
    case GET_THUMBNAIL_ATTACHMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_VOUCHER_LIST_SUCCESS:
      return {
        ...state,
        voucherList: action.payload,
      }
    case GET_VOUCHER_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case SEND_EMAIL_SUCCESS:
      return {
        ...state,
        send_email_response: action.payload,
      }
    case SEND_EMAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ADVERT_INTEREST_RATE_SUCCESS:
      return {
        ...state,
        advertInterestRate: action.payload
      }
    case GET_ADVERT_INTEREST_RATE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case RESET_GENERAL_STATE:
      return {
        ...state,
      }

    case RESET_ATTACHMENT_STATE:
      return {
        ...state,
        attachment: [],
      }

    case RESET_THUMBNAIL_ATTACHMENT_STATE:
      return {
        ...state,
        thumbnailAttachment: [],
      }

    case RESET_PROFILE_ATTACHMENT_STATE:
      return {
        ...state,
        profileAttachment: []
      }

    case RESET_EMAIL_STATE:
      return {
        ...state,
        send_email_response: []
      }
    default:
      return state
  }
}

export default General
